import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import { BookLetsEditionView } from "../../models/views/education/BookLetsEditionView";
import BaseService from "../base/BaseService";

export default class BookletsService extends BaseService {
    getPages(queryInfo: QueryPagesDTO): Promise<TableData<BookLetsEditionView>> {
        return axios.get(`/StudentBookLets/MyBooklets`, { params: queryInfo })
            .then(function (response: AxiosResponse<TableData<BookLetsEditionView>, any>) {
                return response.data;
            });
    }

    getMyCoachings(): Promise<BookLetsEditionView[]> {
        return axios.get(`/StudentBookLets/MyCoachings`)
            .then(function (response: AxiosResponse<BookLetsEditionView[], any>) {
                return response.data;
            });
    }

    getById(id: number, skipFileType?: boolean): Promise<BookLetsEditionView> {
        return axios.get(`/StudentBookLets/MyBooklets/${id}`, { params: { skipFileType } })
            .then(function (response: AxiosResponse<BookLetsEditionView, any>) {
                return response.data;
            });
    }

    createBookMark(id: number): Promise<any> {
        return axios.post(`/BookletBookMark/${id}`)
            .then(function (response: AxiosResponse<any, any>) {
                return response.data;
            });
    }

    deleteBookMark(id: number): Promise<any> {
        return axios.delete(`/BookletBookMark/${id}`)
            .then(function (response: AxiosResponse<any, any>) {
                return response.data;
            });
    }

    getBookMark(): Promise<BookLetsEditionView[]> {
        return axios.get(`/StudentBookLets`)
            .then(function (response: AxiosResponse<BookLetsEditionView[], any>) {
                return response.data;
            });
    }
}